<template>
  <div class="header">
    <div class="navbar bg-primary text-primary-content">
      <button class="btn btn-ghost text-xl">食事記録アプリ</button>
    </div>
    <div class="mx-auto w-full px-2 md:w-1/2">
      <div class="chat chat-start">
        <div class="chat-image avatar">
          <div class="w-10 rounded-full">
            <img
              alt="Tailwind CSS chat bubble component"
              src="images/icon.PNG"
            />
          </div>
        </div>
        <div class="chat-bubble text-left max-w-xl mt-4">
          <p>ご確認をよろしくお願いいたします。</p>
          <p>食事の中で大切にしたいこと</p>
          <ul>
            <li>・美容意識</li>
            <li>・もう少し太りたい</li>
            <li>・睡眠の質向上</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderComp',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
